export default {
    howToShop:'How to shop?',
    howToShopLink:'how-to-shop/electronic',
    help:'Help',
    helpLink:'help',
    returnTicket: 'Return ticket',
    myPurchasesLink: 'usuario/miscompras',
    home: 'Home'
}